<template></template>

<script>
var scrollIntoView = require('scroll-into-view');

export default {
    name: 'subpages',

    data() {
        return {
            activeIndex: 0,
        };
    },

    mounted() {
        window.scrollTo(0, 0); // execute it straight away

        addEventListener('hashchange', (event) => {
            this.setPageThroughHash();
        });

        this.setPageThroughHash();
    },

    methods: {
        setPageThroughHash() {
            const hash = window.location.hash;

            if (hash && hash !== '') {
                this.$nextTick(() => {
                    let links = this.$refs.subpagecontainer.querySelectorAll('a.anchorlink');
                    let matchingIndex = null;

                    for (let index = 0; index < links.length; index++) {
                        if (links[index].href.indexOf(hash) >= 0) {
                            matchingIndex = index;
                        }
                    }

                    if (matchingIndex) {
                        this.activeIndex = matchingIndex;
                    }
                });
            }
        },

        changeIndex(index, name) {
            this.activeIndex = index;
            window.location.hash = name
                .toString()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .toLowerCase()
                .trim()
                .replace(/\s+/g, '-')
                .replace(/[^\w-]+/g, '')
                .replace(/--+/g, '-');
        },
    },

    watch: {
        activeIndex() {
            scrollIntoView(this.$refs.subpagecontainer);
        },
    },
};
</script>
